import {
  GetCollaboratorsCmSheetCoursesResponse,
  UpdateCollaboratorsCmSheetCourseRequest,
} from "../../../types/api/collaborators.type";
import httpClient from "../../client/HttpClient";

const CmSheetCoursesService = {
  async list(
    cmSheetId: number,
  ): Promise<GetCollaboratorsCmSheetCoursesResponse> {
    const response =
      await httpClient.get<GetCollaboratorsCmSheetCoursesResponse>(
        `v1/cm-sheets/${cmSheetId}/courses`,
      );
    return response;
  },
  async update(
    cmSheetId: number,
    body: UpdateCollaboratorsCmSheetCourseRequest,
  ): Promise<void> {
    await httpClient.patch(`v1/cm-sheets/${cmSheetId}/courses`, body);
  },
};

export default CmSheetCoursesService;
